// extracted by mini-css-extract-plugin
export default {"cta":"cta--mp-MXEqA"};